module.exports = __webpack_public_path__ + "static/pokoj-nr1-photo04-b162abb688b47ed382e5f001e22f0f02.jpg";